import { useContext, useEffect, useState } from "react";
import { StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../components/ButtonIcon";
import PageTitle from "../../components/PageTitle";
import { AuthContext } from "../../contexts/auth";
import { IS_WEB } from "../../services/Config";
import queryString from 'query-string';
import { SessionStorage } from "../../services/SessionStorage";

import {
  PaymentData,
  PaymentTicketSoftpark
} from "../../services/Api/payment";

import PaymentFormList from "../../components/PaymentsFormList";
import { GlobalContext } from "../../contexts/global";
import { PaymentContext } from "../../contexts/payment";
import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";
import ConfirmCvv from "../Wallet/components/ConfirmCvv";
import Ticket from "./components/Ticket";
import GetCardType from "../../helpers/creditCard";

export default function PaymentTicket({ navigation, route }) {
  const [unityInfo, setUnityInfo] = useState(null);
  const { setLoading, setShowAlert, showAlert } = useContext(GlobalContext);
  const { setIsSignUp, loginType } = useContext(AuthContext);
  const [timeoutTicket, setTimeoutTicket] = useState(false)

  const { selectedPaymentForm,
    newCard,
    validNewCard,
    saveCard,
    cardNumber,
    cardExpiration,
    cardBrand,
    cardName,
    saveCardApi,
    clearInput } = useContext(PaymentContext);

  const [modalVisible, setModalVisible] = useState(false);
  const qrCodeData = route.params;

  useEffect(() => {
    (async () => {
      setLoading({ show: true, message: "Carregando informações do ticket" })
      PaymentData(qrCodeData)
        .then((value) => {
          let dataArray = value.data
          if (Array.isArray(dataArray)){
            if(dataArray.length > 0) setUnityInfo(dataArray[0]);
            else {
              setShowAlert({
                type: "warning",
                title: "Atenção",
                message: "Ticket não localizado.",
                show: true,
                confirmText: "OK",
                pressConfirm: () => {
                  setShowAlert({ ...showAlert, show: false });
                  if(IS_WEB){
                    setIsSignUp(false);
                    if(loginType && loginType === "autologin" && IS_WEB){
                      window.location.reload();
                    }else{
                      navigation.goBack();
                    }
                  }
                  else{
                    navigation.goBack()
                  }
                },
              });
            }
          }
        })
        .catch((error) => {
          const errorMessage = error.message || error.erro || "Ocorreu um erro ao tentar consultar o ticket";
          setShowAlert({
            type: "alert",
            title: "Atenção",
            message: errorMessage,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
              if(IS_WEB){
                setIsSignUp(false);
                if(loginType && loginType === "autologin" && IS_WEB){
                  window.location.reload();
                }else{
                  navigation.goBack();
                }
              }
              else{
                navigation.goBack()
              }
            },
          });
        })
        .finally(() => {
          clearInput()
          setLoading({ show: false, message: "" })
        }
        );
    })();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutTicket(true)
    }, 60000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(()=> {
    if(timeoutTicket)
    setShowAlert({
      type: "alert",
      title: "Oops",
      message: "Tempo expirado, leia o ticket novamente.",
      show: true,
      confirmText: "OK",
      pressConfirm: () => {
        setTimeoutTicket(false)
        setShowAlert({ ...showAlert, show: false });

        if(IS_WEB){
          setIsSignUp(false);
          if(loginType && loginType === "autologin" && IS_WEB){
            window.location.reload();
          }else{
            navigation.goBack();
          }
        }
        else{
          navigation.goBack()
        }

      },
      showConfirmButton: true,
    });
  }, [timeoutTicket])

  const paymentTicketApi = (selectedCardData, cvv) => {    
    setLoading({ show: true, message: "Realizando o pagamento" });
    let valor = +unityInfo.valorPagar.replace(',','.')
    PaymentTicketSoftpark(
      valor.toFixed(2),
      selectedCardData.cardNumber ? Encrypt(selectedCardData.cardNumber.replace(/\s/g, "")) : null,
      cvv,
      selectedCardData.expiration,
      unityInfo.idGaragem,
      unityInfo.placa,
      unityInfo.numeroTicket,
      selectedCardData.idCard,
      selectedCardData.payType,
      selectedCardData.idFraction,
      selectedCardData.amountFraction,
      unityInfo.nmEstacionamento
    )
      .then((value) => {
        if (IS_WEB) {
          SessionStorage.addPaymentToHistory({
            ...value,
            unityInfo,
            paymentMethod: selectedCardData.payType === 0 ? 'credit_card' : 
                         selectedCardData.payType === 1 ? 'wallet' :
                         selectedCardData.payType === 2 ? 'shared_wallet' : 'fraction',
            cardLastDigits: selectedCardData.cardNumber ? selectedCardData.cardNumber.slice(-4) : null
          });
        }
        navigation.reset({ index: 0, routes: [{ name: "PaymentReceipt", params: value }] })
      })
      .catch((error) => {
        const errorMessage = error.message || error.erro || "Não foi possível realizar o pagamento";
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: errorMessage,
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
          showConfirmButton: true,
        });
      })
      .finally(() => {
        clearInput()
        setLoading({ show: false, message: "Realizando o pagamento" });
      });
  };



  const disabledButton =
    !!unityInfo && (!!selectedPaymentForm || newCard) ? false : true;

  const payTypeName = (payType) => {
    switch (payType) {
      case 1:
        return "carteira"
        break;
      case 2:
        return "carteira compartilhada"
      case 3:
        return "fração"
      default:
        return "não informado"
    }
  }
  return (
    <PageTitle title={"PAGAR MEU TICKET"} navigation={navigation}>
      <KeyboardAwareScrollView
        style={{ flex: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        {unityInfo != null ? (
          <View
            style={{ flex: 1, justifyContent: "flex-start", width: "100%" }}
          >
            <TouchableWithoutFeedback onPress={() => navigation.navigate("UnityDetails", unityInfo.idGaragem)}>
              <View
                style={{
                  alignItems: "center",
                  padding: 8,
                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Icon size={32} name={"map-marker-outline"} />
                <Text style={{ fontSize: Fonts.FONT_SIZE_16, marginLeft: 4, }}>
                  {unityInfo.nmUnidade}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <Ticket unityInfo={unityInfo} />
            <View style={styles.viewSecundaria}>
              <View style={styles.titleBar}>
                <Text style={styles.titleText}>{"FORMAS DE PAGAMENTOS"}</Text>
              </View>
              <PaymentFormList totalAmount={unityInfo.valorPagar} hasFractions={!IS_WEB} hasWallets={!IS_WEB}/>
              <IconButton
                textoBotao={"Realizar pagamento"}
                onPress={() => {
                  if (newCard) {
                    if (validNewCard()) {
                      if (saveCard && !IS_WEB) {
                        let cardBrandType = GetCardType(cardNumber.replace(/\s/g, ""));
                        setLoading({ show: true, message: "Salvando cartão" })
                        saveCardApi(cardBrandType)
                      }
                    }
                  }
                  let payType = selectedPaymentForm.payType ?? 0
                  if (payType > 0)
                    setShowAlert({
                      type: "info",
                      title: "Atenção",
                      message: `Confirmar pagamento via ${payTypeName(payType)}?`,
                      show: true,
                      cancelText: "Não",
                      confirmText: "Sim",
                      pressCancel: () => {
                        setShowAlert({ ...showAlert, show: false });
                      },
                      pressConfirm: () => {
                        paymentTicketApi(selectedPaymentForm, "")
                        setShowAlert({ ...showAlert, show: false });
                      },
                      showConfirmButton: true,
                    });
                  else
                    setModalVisible(true);

                  setLoading({ show: false, message: "Salvando cartão" })
                }}
                iconName={"currency-usd"}
                estilo={{
                  backgroundColor: disabledButton
                    ? Colors.GRAY_DARK
                    : Colors.SUCCESS,
                  width: "100%",
                  marginTop: 16
                }}
                disabled={disabledButton}
              />
            </View>
            <ConfirmCvv
              modalVisible={modalVisible}
              setModalVisible={setModalVisible}
              onPress={(cvv) => paymentTicketApi(newCard ?
                {
                  brand: cardBrand,
                  expiration: cardExpiration,
                  cardNumber: cardNumber,
                  personName: cardName,
                  payType: 0
                }
                :
                selectedPaymentForm, cvv)}
              countCell={3}
            />
          </View>
        ) : (
          <></>
        )}
      </KeyboardAwareScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  titleText: {
    color: Colors.BLACK,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
  titleBar: {
    alignItems: "center",
    flexDirection: "row",
    padding: 12,
    justifyContent: "center",
  },
  viewSecundaria: {
    backgroundColor: Colors.WHITE,
    width: "100%",
    flex: 1,
    flexGrow: 1,
    padding: 4,
    justifyContent: "center",
    alignItems: "center",
  },
});
